import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import { Card, CardActions, CardContent, CardHeader, Divider } from '@mui/material';
import useAsyncInitalizeCalendar from '../../../hooks/useAsyncInitalizeCalendar';
import { RequestStatus } from '../../../sic-lib/enums/RequestStatus';
import { TimeZoneSettings } from '../../../sic-lib/types/GeneralSettings';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import ButtonLoading from '../../Shared/ButtonLoading';

const useStyles = makeStyles()((theme: Theme) => ({}));

interface Props {
    timeZone: [TimeZoneSettings];
}

export default function CalendarSettings({ timeZone }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const userState = useAppSelector(state => {
        return {
            userGoogleAccountId: state.user.googleAccountId,
            userCalendarId: state.user.googleCalendarId || null,
        };
    });

    const { requestStatus, asyncInitalizeGoogleCalendar } = useAsyncInitalizeCalendar();

    const handleEnableCalendar = async () => {
        await asyncInitalizeGoogleCalendar();
    };

    return (
        <Card>
            <CardHeader title="Google Calendar" />
            <Divider />
            <CardContent>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >
                    <Typography component="p" variant="body2">
                        Current Google Account:
                    </Typography>
                    <Typography component="p" variant="body2">
                        {userState.userGoogleAccountId
                            ? userState.userGoogleAccountId
                            : 'Not Connected'}
                    </Typography>
                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >
                    <Typography component="p" variant="body2">
                        Synchronization Status:
                    </Typography>
                    <Typography component="p" variant="body2">
                        {userState.userCalendarId
                            ? 'Synchronization enabled '
                            : 'Synchronization disabled'}
                    </Typography>
                </Grid>
            </CardContent>
            <CardActions>
                {!userState.userCalendarId && (
                    <ButtonLoading
                        variant="outlined"
                        isLoading={requestStatus === RequestStatus.active}
                        onClick={handleEnableCalendar}
                    >
                        Enable Calendar Sync
                    </ButtonLoading>
                )}
            </CardActions>
        </Card>
    );
}
